//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import { commonService } from "../../_services";
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { categoryActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class Categories extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            categoryAdd: false,
            shopKeeperData: [],
            categoryTitle: '',
            categoryError: '',
            categorySuccess: '',
            allCategories: [],
            addCat: false,
            editingCatId: '',
            editingCatTitle: '',
            editingCatStatus: '',
            editingCatHold: false,
            categoryImage: '',
            allActiveCat: [],
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));

        dispatch(categoryActions.getAllActiveCategory(apiConstants.GET_ALL_ACTIVE_CATEGORIES_FOR_ADMIN));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        const { dispatch } = props;



        if (props.deleteCategory.deleteCat !== undefined &&
            props.deleteCategory.deleteCat.data !== undefined &&
            props.deleteCategory.deleteCat.data.data !== undefined &&
            props.deleteCategory.deleteCat.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });


                this.setState({ deletingCat: '', openDeleteCat: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));

            }
        }

        //get all active categories
        if (props.getAllActiveCat !== undefined &&
            props.getAllActiveCat.activeCat !== undefined &&
            props.getAllActiveCat.activeCat.data !== undefined &&
            props.getAllActiveCat.activeCat.data.data) {
            this.setState({ allActiveCat: props.getAllActiveCat.activeCat.data.data });
        }




        //check if category already exist with same name
        if (
            props.addCategory !== undefined &&
            props.addCategory.addedCat !== undefined &&
            props.addCategory.addedCat === false
        ) {
            this.setState({ categoryError: 'Category with same name already exist!!', categorySuccess: '' })
        }

        //IF CATEGORY ADDED SUCCESSFULLY
        if (
            props.addCategory !== undefined &&
            props.addCategory.addedCat !== undefined &&
            props.addCategory.addedCat.data !== undefined &&
            props.addCategory.addedCat.data.success !== undefined &&
            props.addCategory.addedCat.data.success === true
        ) {
            const thisHolder = this;
            if (thisHolder.state.addCat === true) {
                this.setState({ categorySuccess: 'Category added successfully!!', categoryError: '' });

                setTimeout(function () {

                    thisHolder.setState({ categorySuccess: '', categoryError: '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
                    dispatch(categoryActions.getAllActiveCategory(apiConstants.GET_ALL_ACTIVE_CATEGORIES_FOR_ADMIN));


                }, 2000);
            }
        }

        console.log("TEST props ",props)
        // GET LIST OF CATEGORIES SUCCESS
        if (props.getCategories !== undefined &&
            props.getCategories.getCatList !== undefined &&
            props.getCategories.getCatList.data !== undefined
        ) {
            const catDataReceived = props.getCategories.getCatList.data;
console.log("TEST ",catDataReceived)
            this.setState({
                allCategories: catDataReceived,
                totalPage: catDataReceived.pagination.totalPages,
                totalDataCount: catDataReceived.pagination.totalCount,
            })

        }

        // check if category is ready to edit
        if (props.getCategory !== undefined &&
            props.getCategory.editCatData !== undefined &&
            props.getCategory.editCatData.data !== undefined &&
            props.getCategory.editCatData.data.allData !== undefined
        ) {
            const editingCatData = props.getCategory.editCatData.data.allData;

            if (this.state.editingCatHold === true) {


                this.setState({
                    editingCatTitle: editingCatData[0].categoryTitle,
                    editingCatParentCat: editingCatData[0].parentCatData[0] !== undefined && editingCatData[0].parentCatData[0]._id !== undefined ? editingCatData[0].parentCatData[0]._id : '',
                    editingCatLogo: editingCatData[0].logo,
                    editingCatStatus: editingCatData[0].status,
                    editingCatHold: false,
                    editingCategoryError: '',
                    editingCategorySuccess: '',
                })
            }

        }


        //check if category already exist with same name while editing
        if (
            props.editCategory !== undefined &&
            props.editCategory.editedCat !== undefined &&
            props.editCategory.editedCat === false
        ) {
            this.setState({ editingCategoryError: 'Category with same name already exist!!', editingCategorySuccess: '' })
        }


        // IF CATEGORY UPDATED SUCCESSFULLY
        if (
            props.editCategory !== undefined &&
            props.editCategory.editedCat !== undefined &&
            props.editCategory.editedCat.data !== undefined &&
            props.editCategory.editedCat.data.success === true
        ) {
            const thisHolder = this;

            if (thisHolder.state.triggerEditCat === true) {

                this.setState({ editingCategoryError: '', editingCategorySuccess: 'Category updated succesfully!!' });
                const thisHolder = this;
                setTimeout(function () {

                    thisHolder.closeEditCatPop();

                    thisHolder.setState({ editingCategoryError: '', editingCategorySuccess: '', triggerEditCat: false });

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));


                }, 2000);
            }
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
    }


    //remove image while editing a category
    removeMainImage = () => {
        this.setState({ editingCatLogo: '' })
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;

        this.setState({ perPage: parseInt(e.target.value) });

        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(categoryActions.getAllCategory(apiConstants.FIND_CATEGORIES, postData));
        } else {
            dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
        }
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (advertisments, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ advertisments, [type]: true })
    };



    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //on change set category title to state
    onChangeCatTitle = (e) => {
        if (e.target.type === "file") {

            var extArr = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
            const files = e.target.files;
            const target = e.target;
            var forimgState = [target.name + "_error"];


            if (extArr.indexOf(files[0].type) > -1) {
                this.setState({ [target.name]: files[0] });

                // let img = new Image()
                // img.src = window.URL.createObjectURL(e.target.files[0])
                // img.onload = () => {

                //     if (img.width === 200 && img.height === 200) {
                //         this.setState({ [target.name]: files[0] });
                //         this.setState({ [forimgState]: "" });
                //         // upload logic here
                //     }
                //     else {
                //         this.setState({ [forimgState]: "Image dimension should not be greater then 200*200!!" });
                //         target.value = null;
                //         this.setState({ [target.name]: '' })
                //     }
                // }


            } else {
                this.setState({ [forimgState]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
        else { this.setState({ [e.target.name]: e.target.value }); }


    }
    onChangeEditCatTitle = (e) => {
        this.setState({ editingCatTitle: e.target.value })
    }
    onChangeEditCatDropdown = (e) => {
        this.setState({ editingCatStatus: e.target.value })
    }


    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            categorySuccess: '',
            categoryAdd: false,
            categoryTitle: '',
            addCat: false
        });
    }

    //save category to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ categoryError: '', categoryImage_error: '' });
        const { categoryTitle, parentcat, categoryImage } = this.state;
        console.log("ssssssssss",this.state.categoryImage)
        if (categoryTitle === undefined || categoryTitle === '') { this.setState({ categoryError: 'Category title required!!' }) }
        else if (categoryImage === undefined || categoryImage === '') { this.setState({ categoryImage_error: 'Category Logo required!!' }) }
        else {

            this.setState({ categoryError: '', addCat: true })

            const postData = {};
            postData.catTitle = categoryTitle;

            if (parentcat !== undefined) {
                postData.parentcat = parentcat;
            }




            const logoImage = new FormData();
            logoImage.append('categoryImage', categoryImage);

            commonService.withTokenAndFormData(apiConstants.SAVE_CATEGORY_LOGO, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined) {
                        postData.catLogo = res.data.data;
                    }
                    // save category data to cololection
                    dispatch(categoryActions.saveCategory(apiConstants.SAVE_CATEGORY, postData));
                },
                error => { }
            );


        }

    }


    handleSubmitEditCat = () => {
        const { dispatch } = this.props;
        this.setState({ categoryImageEditing_error: '', editingCategoryError: '' });
        const { editingCatTitle, editingCatLogo, editingCatParentCat, editingCatStatus, editingCatId, categoryImageEditing } = this.state;
        if (editingCatTitle === undefined || editingCatTitle === '') {
            this.setState({ editingCategoryError: 'Category title required!!' })
        }
        else if (editingCatLogo === '' && categoryImageEditing === '') {

        }
        else {
            this.setState({ categoryImageEditing_error: '', editCat: true, triggerEditCat: true, });


            const postData = {};
            postData.catId = editingCatId;
            postData.catTitle = editingCatTitle;
            postData.catStatus = editingCatStatus;

            if (editingCatParentCat !== undefined) {
                postData.catParent = editingCatParentCat;
            } else { postData.catParent = ""; }


            const logoImage = new FormData();
            logoImage.append('categoryImage', categoryImageEditing);

            commonService.withTokenAndFormData(apiConstants.SAVE_CATEGORY_LOGO, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined && res.data.data !== false) {
                        postData.catLogo = res.data.data; //console.log("res.data.data---------", res.data.data);
                    } else {
                        postData.catLogo = editingCatLogo; //console.log("res.data.editingCatLogo---------", editingCatLogo);
                    }
                    // save category data to cololection
                    dispatch(categoryActions.editCategory(apiConstants.EDIT_CATEGORY, postData));
                },
                error => { }
            );

        }

    }


    // popup for editing the category
    editCategories = (catId) => {
        const { dispatch } = this.props;
        this.setState({
            editingCatId: catId,
            enableEditingCat: true,
            editingCategoryError: '',
            editingCategorySuccess: '',
            editingCatHold: true,
            categoryImageEditing_error: ''
        });

        const postData = {};
        postData.catId = catId;

        dispatch(categoryActions.getCategoryById(apiConstants.GET_CATEGORY_BY_ID, postData));
    }

    closeEditCatPop = () => {
        this.setState({ editingCatId: '', enableEditingCat: false, triggerEditCat: false });
    }


    openAddCategory = () => {
        this.setState({
            categoryAdd: !this.state.categoryAdd,
            categorySuccess: '',
            categoryTitle: '',
            parentcat: '',
            categoryImage: '',
            categoryImage_error: '',
            addCat: false
        });

    }

    handleClose = () => {
        this.setState({ categoryAdd: !this.state.categoryAdd })
    };


    deletePopupOpen = (catid) => {
        this.setState({ deletingCat: catid, openDeleteCat: true });
    }

    closeDeletePopup = (catid) => {
        this.setState({ deletingCat: '', openDeleteCat: false });
    }

    // after conform click to delete cat
    deletingCatRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.catId = this.state.deletingCat;
        dispatch(categoryActions.deleteCategory(apiConstants.DELETE_CATEGORY, postData));
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_CATEGORY}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_CATEGORY}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddCategory()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_CATEGORY_TITLE}</th>
                                                    <th scope="10%">{siteConstants.GEN_CATEGORY_PARENT_TITLE}</th>
                                                    <th scope="10%">{siteConstants.GEN_CATEGORY_LOGO}</th>
                                                    <th scope="col">{siteConstants.GEN_CATEGORY_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.allCategories.data != undefined &&
                                                        this.state.allCategories.data.length > 0 ?
                                                        this.state.allCategories.data.map((thisCat, index) => {
                                                            let stText = 'Active';
                                                            if (thisCat.status === 0) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisCat.categoryTitle}</td>
                                                                    <td>
                                                                        {
                                                                            thisCat.parentCatData !== undefined && thisCat.parentCatData.length > 0 ? thisCat.parentCatData.map((parCt) => { return parCt.categoryTitle; }) : "--"
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            thisCat.logo !== undefined && thisCat.logo ? (
                                                                                <div className={classes.borderedImgTable}>
                                                                                    <img src={`${config.imgPath}` + '/uploads/category-logo/' + thisCat.logo} className={classes.tableImg} crossOrigin="anonymous" />
                                                                                </div>
                                                                            ) : '--'
                                                                        }

                                                                    </td>

                                                                    <td>{stText}</td>
                                                                    <td>
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editCategories(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add category popup */}
                    <Dialog
                        open={this.state.categoryAdd}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>{siteConstants.LABEL_CATEGORY_POPUP}</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div class="row">


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_SELECT_PARENT_CATEGORY}</label>
                                        <select
                                            className="form-control"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            name="parentcat"
                                        >
                                            <option value=""> </option>
                                            {
                                                this.state.allActiveCat != undefined &&
                                                    this.state.allActiveCat.length > 0 ?
                                                    this.state.allActiveCat.map((thisCat, index) => {
                                                        let stText = 'Active';
                                                        if (thisCat.status === 0) { stText = 'Deactive'; }

                                                        return <option value={thisCat._id}> {thisCat.categoryTitle} </option>
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>




                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_FIELD}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.LABEL_CATEGORY_FIELD}
                                            className="form-control"
                                            name="categoryTitle"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.categoryError}</p>
                                    </div>
                                </div>


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="categoryImage"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.categoryImage_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.categorySuccess}</p>
                                    </div>
                                </div>


                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.enableEditingCat}
                        aria-labelledby="edit-category-title"
                        aria-describedby="edit-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>{siteConstants.LABEL_CATEGORY_EDIT_POPUP}</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div class="row">


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_SELECT_PARENT_CATEGORY}</label>
                                        <select
                                            className="form-control"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            name="editingCatParentCat"
                                            value={this.state.editingCatParentCat !== undefined ? this.state.editingCatParentCat : ''}
                                        >
                                            <option value=""> </option>
                                            {
                                                this.state.allActiveCat != undefined &&
                                                    this.state.allActiveCat.length > 0 ?
                                                    this.state.allActiveCat.map((thisCat, index) => {
                                                        let stText = 'Active';
                                                        if (thisCat.status === 0) { stText = 'Deactive'; }

                                                        return <option value={thisCat._id}> {thisCat.categoryTitle} </option>
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>



                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_FIELD}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeEditCatTitle(e)}
                                            placeholder={siteConstants.LABEL_CATEGORY_FIELD}
                                            className="form-control"
                                            value={this.state.editingCatTitle !== undefined ? this.state.editingCatTitle : ''}
                                        />
                                    </div>
                                </div>


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="categoryImageEditing"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.categoryImageEditing_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.categorySuccess}</p>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    {
                                        this.state.editingCatLogo !== undefined &&
                                            this.state.editingCatLogo !== null &&
                                            this.state.editingCatLogo !== false &&
                                            this.state.editingCatLogo !== '' ?
                                            <div className={classes.borderedImg}>
                                                <img src={`${config.imgPath}` + '/uploads/category-logo/' + this.state.editingCatLogo} className={classes.pageImg} />
                                                <span className={classes.removeImg} onClick={() => this.removeMainImage()}>x</span>
                                            </div>
                                            : ''
                                    }
                                </div>



                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CATEGORY_STATUS}</label>
                                        <select
                                            onChange={(e) => this.onChangeEditCatDropdown(e)}
                                            className="form-control"
                                        >
                                            <option value="1" selected={this.state.editingCatStatus === 1}>Active</option>
                                            <option value="0" selected={this.state.editingCatStatus === 0}>Deactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <p style={{ color: 'red' }}>{this.state.editingCategoryError}</p>
                                    <p style={{ color: 'green' }}>{this.state.editingCategorySuccess}</p>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEditCat(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeEditCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteCat} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingCatRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addCategory, getCategories, getCategory, editCategory, getAllActiveCat, deleteCategory } = state;
    return {
        language,
        addCategory,
        getCategories,
        getCategory,
        editCategory,
        getAllActiveCat,
        deleteCategory

    };
}

// const connectedShopkeeper = connect(mapStateToProps)(Categories);
// export { connectedShopkeeper as Categories };
export default connect(mapStateToProps)(withStyles(styles)(Categories));
